module.exports = __webpack_public_path__ + "static/img/6.1.7a2afe4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/zh/6.1.png
// module id = 5arr
// module chunks = 0